// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import useCredentialOffers from '@hooks/queries/credential/offer/useCredentialOffers';
import { CredentialOffer } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Model/Offer';
import { useParties } from '../../contexts/PartiesContext';
import TemplateContract from '../../utils/TemplateContract';

export const useInboundCredentialOffers = () => {
  const { party } = useParties();
  const transform = (data: TemplateContract<CredentialOffer>[]) => {
    return data.filter((offer) => offer.payload.holder === party).length;
  };
  return useCredentialOffers(transform);
};
